import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

export function mount(container, gltfScene, texture, onProgressCallback) {
    // 1. Setup Loading Manager
    const manager = new THREE.LoadingManager();
    
    manager.onProgress = (url, itemsLoaded, itemsTotal) => {
        const percentage = (itemsLoaded / itemsTotal) * 100;
        if (onProgressCallback) onProgressCallback(percentage);
    };

    const scene = new THREE.Scene();
    const textureLoader = new THREE.TextureLoader(manager); // Pass manager here
    const gltfLoader = new GLTFLoader(manager);    // Pass manager here
    
    const bakedTexture = textureLoader.load("/backend/static/" + texture);
    bakedTexture.colorSpace = THREE.SRGBColorSpace;
    bakedTexture.flipY = false;
    const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture });
    
    gltfLoader.load("/backend/static/" + gltfScene, (gltf) => {
        gltf.scene.traverse((child) => {
            if (child.isMesh) child.material = bakedMaterial;
        });
        scene.add(gltf.scene);
    });


    const initialWidth = 1;
    const initialHeight = 1;

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    
    const camera = new THREE.PerspectiveCamera(45, 1, 0.1, 100);
    camera.position.set(5.7, 4, 5.7);
    
    const controls = new OrbitControls(camera, renderer.domElement);
    controls.enableZoom = false;
    controls.enablePan = false;
    controls.minDistance = 3;
    controls.maxDistance = 10;
    controls.target.set(0, 1.5, 0);
    controls.enableDamping = true;
    controls.minAzimuthAngle = -0.2; // rot oraria su Z
    controls.maxAzimuthAngle = 1.8; // rot antioraria su Z
    controls.minPolarAngle = 0.9; // rot in alto (0.0: verticale)
    controls.maxPolarAngle = 1.7; // rot in basso

    function resize() {
        const container = renderer.domElement.parentNode;
        if (container) {
            renderer.setSize(container.offsetWidth, container.offsetHeight);
            camera.aspect = container.offsetWidth / container.offsetHeight;
            camera.updateProjectionMatrix();
        }
    }
    
    window.addEventListener('resize', resize);

    // 2. Control the animation loop so we can stop it
    let animationId;
    const tick = () => {
        controls.update();
        renderer.render(scene, camera);
        animationId = window.requestAnimationFrame(tick);
    };
    tick();

    if (container) {
        container.insertBefore(renderer.domElement, container.firstChild);
        setTimeout(resize, 100);
    }

    return () => {
        // Stop the loop
        window.cancelAnimationFrame(animationId);
        window.removeEventListener('resize', resize);
        
        if (container && renderer.domElement.parentNode === container) {
            container.removeChild(renderer.domElement);
        }

        // Clean up GPU resources
        renderer.dispose();
        bakedTexture.dispose();
        bakedMaterial.dispose();
        scene.traverse((child) => {
            if (child.isMesh) {
                child.geometry.dispose();
                if (child.material.dispose) child.material.dispose();
            }
        });
    };
}